module.exports = __webpack_public_path__ + "static/media/3_Heaven and hell_DE.38a4fccb.txt";